import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { Select2Data } from "../../../utils/common";

//Faq - Get All
export const AllFAQ = createAsyncThunk(
  "common/faqs/all-faq/:id",
  async ({ faqcatId, question = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllFAQ}/${faqcatId}?question=${question}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//FAQ Category
export const AllFAQCategory = createAsyncThunk(
  "common/faqs/all-faqcategory",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllFAQCategory}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Popular tag - Get All
export const AllPopularTag = createAsyncThunk(
  "common/blogs/all-populartag",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllPopularTag}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Blog - Get All
export const AllBlog = createAsyncThunk(
  "common/blogs/all-blog/:id",
  async ({ poptagId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBlog}/${poptagId}?name=${name}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//ServiceInclude - Get All
export const AllServiceInclude = createAsyncThunk(
  "common/services/all-serviceinclude",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllServiceInclude}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Key Benefit - Get All
export const AllKeyBenefit = createAsyncThunk(
  "common/services/all-keybenefit",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllKeyBenefit}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Banner - Get All
export const AllBanner = createAsyncThunk(
  "common/aboutus/all-banner",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBanner}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//VisionMission - Get All
export const AllVisionMission = createAsyncThunk(
  "common/aboutus/all-visionmission",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllVisionMission}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Why choose us - Get All
export const AllWhyChooseUs = createAsyncThunk(
  "common/aboutus/all-whychooseus",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllWhyChooseUs}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//People behind work - Get All
export const AllPeopleBehindWork = createAsyncThunk(
  "common/aboutus/all-peoplebehindwork",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPeopleBehindwork}?name=${filter}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Why we rank - Get All
export const AllWhyWeRank = createAsyncThunk(
  "common/aboutus/all-whywerank",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllWhyWeRank}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//What Make different - Get All
export const AllWhatMakeDifferent = createAsyncThunk(
  "common/aboutus/all-whatmakedifferent",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllWhatMakeDifferent}?name=${filter}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//We Focus - Get All
export const AllWeFocus = createAsyncThunk(
  "common/aboutus/all-wefocus",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllWeFocus}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//What our customer say - Get All
export const AllWhatOurCustomerSay = createAsyncThunk(
  "common/aboutus/all-whatourcustomersay",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllWhatOurCustomerSay}?name=${filter}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Man behind power - Get All
export const AllManBehindPower = createAsyncThunk(
  "common/aboutus/all-manbehindpower",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllManBehindPower}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Best for - Get All
export const AllBestFor = createAsyncThunk(
  "common/services/all-bestfor",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBestFor}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Service - Get All
export const AllService = createAsyncThunk(
  "common/services/all-service/:id",
  async (
    { bestforId, servincludeId, keybenefitId, name = "" },
    { rejectWithValue },
  ) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllService}/${bestforId}/${servincludeId}/${keybenefitId}?name=${name}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Gallery - Get All
export const AllGallery = createAsyncThunk(
  "common/gallerys/all-gallery",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllGallery}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//App Setup - Get All
export const AllAppSetup = createAsyncThunk(
  "common/customizations/all-appsetup",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllAppSetup}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Avg Monthly Bill - Get All
export const AllAvgMonthlyBill = createAsyncThunk(
  "common/masters/all-avgmonthlybill",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllAvgMonthlyBill}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Consultation Type - Get All
export const AllConsultationType = createAsyncThunk(
  "common/masters/all-consultationtype",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllConsultationType}?name=${filter}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Trusted across community - Get All
export const AllTrustedAcrossCommunity = createAsyncThunk(
  "common/masters/all-trustedacrosscommunity",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllTrustedAcrossCommunity}?name=${filter}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Contact Us - Get All
export const AllContactUs = createAsyncThunk(
  "common/contactuss/all-contactus",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllContactUs}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Country - Get All
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      //return await Select2Data(res.data.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ countryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllState}/${countryId}?name=${name}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      // You can adjust Select2Data if necessary
      //return await Select2Data(res.data.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//City - Get All (for a specific State)
export const AllCity = createAsyncThunk(
  "common/masters/all-city/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}/${stateId}?name=${name}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      // You can adjust Select2Data if necessary
      //return await Select2Data(res.data.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Pincode - Get All (for a specific City)
export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${cityId}?name=${name}`,
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Subsidy Banner - Get All
export const AllSubsidyBanner = createAsyncThunk(
  "common/subsidypolicys/all-subsidybanner",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSubsidyBanner}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//New Update - Get All
export const AllNewUpdate = createAsyncThunk(
  "common/subsidypolicys/all-newupdate",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllNewUpdate}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Latest announcment - Get All
export const AllLatestAnnouncement = createAsyncThunk(
  "common/subsidypolicys/all-latestannouncement",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllLatestAnnouncement}?name=${filter}`,
      );

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Latest announcment - Get All
export const AllElectricity = createAsyncThunk(
  "common/subsidypolicys/all-electricity",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllElectricity}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Rooftop solar - Get All
export const AllRooftopSolar = createAsyncThunk(
  "common/subsidypolicys/all-rooftopsolar",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllRooftopSolar}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Subsidy benefit - Get All
export const AllSubsidyBenefit = createAsyncThunk(
  "common/subsidypolicys/all-subsidybenefit",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllSubsidyBenefit}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Privacy Policy - Get All
export const AllPrivacyPolicy = createAsyncThunk(
  "common/privacypolicys/all-privacypolicy",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllPrivacyPolicy}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Terms of service - Get All
export const AllTermsOfService = createAsyncThunk(
  "common/termsofservices/all-termsofservice",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTermsOfService}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Home Banner - Get All
export const AllHomeBanner = createAsyncThunk(
  "common/homepage/all-homebanner",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllHomeBanner}?name=${filter}`);

      const rawData = res?.data?.data || [];

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Total services dashboard - Get All
export const AllTotalServices = createAsyncThunk(
  "common/dashboard/all-totalservices",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTotalServices}?name=${filter}`);

      const rawData = res?.data?.data || {};

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllKeyRequirements = createAsyncThunk(
  "common/dashboard/all-keyrequirements",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllKeyRequirements}?name=${filter || ""}`,
      );

      const rawData = res?.data?.data || {};

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllJobTypes = createAsyncThunk(
  "common/dashboard/all-jobtypes",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllJobType}?name=${filter || ""}`);

      const rawData = res?.data?.data || {};

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllLocationTypes = createAsyncThunk(
  "common/dashboard/all-locationtypes",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllLocationType}?name=${filter || ""}`,
      );

      const rawData = res?.data?.data || {};

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AllTimeTypes = createAsyncThunk(
  "common/dashboard/all-timetypes",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllTimeType}?name=${filter || ""}`);

      const rawData = res?.data?.data || {};

      return rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_country: [],
    all_state: [],
    all_city: [],
    all_pincode: [],
    all_faq: [],
    all_populartag: [],
    all_serviceinclude: [],
    all_keybenefit: [],
    all_banner: [],
    all_visionmission: [],
    all_whychooseus: [],
    all_peoplebehindwork: [],
    all_whywerank: [],
    all_whatmakedifferent: [],
    all_wefocus: [],
    all_whatourcustomersay: [],
    all_manbehindpower: [],
    all_bestfor: [],
    all_service: [],
    all_appsetup: [],
    all_avgmonthlybill: [],
    all_trustedacrosscommunity: [],
    all_blog: [],
    all_subsidybanner: [],
    all_newupdate: [],
    all_subsidybenefit: [],
    all_privacypolicy: [],
    all_termsofservice: [],
    all_homebanner: [],
    all_everyspace: [],
    all_gallery: [],
    all_faqcategory: [],
    all_totalservices: 0,
    all_contactus: [],
    all_freeconsultation: [],
    all_consultationtype: [],
    all_latestannouncement: [],
    all_electricity: [],
    all_rooftopsolar: [],
    all_keyrequirements: [],
    all_jobtypes: [],
    all_locationtypes: [],
    all_timestypes: [],
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllCity actions
      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for FAQ
      .addCase(AllFAQ.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllFAQ.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_faq = action.payload || [];
      })
      .addCase(AllFAQ.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for FAQ category
      .addCase(AllFAQCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllFAQCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_faqcategory = action.payload || [];
      })
      .addCase(AllFAQCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for popular tag
      .addCase(AllPopularTag.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPopularTag.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_populartag = action.payload || [];
      })
      .addCase(AllPopularTag.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for Blog
      .addCase(AllBlog.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBlog.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_blog = action.payload || [];
      })
      .addCase(AllBlog.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for service include
      .addCase(AllServiceInclude.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllServiceInclude.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_serviceinclude = action.payload || [];
      })
      .addCase(AllServiceInclude.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for key benefit
      .addCase(AllKeyBenefit.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllKeyBenefit.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_keybenefit = action.payload || [];
      })
      .addCase(AllKeyBenefit.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Banner actions
      .addCase(AllBanner.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllBanner.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_banner = action.payload || [];
      })

      .addCase(AllBanner.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Vision Mission actions
      .addCase(AllVisionMission.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllVisionMission.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_visionmission = action.payload || [];
      })

      .addCase(AllVisionMission.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All why choose us actions
      .addCase(AllWhyChooseUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllWhyChooseUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whychooseus = action.payload || [];
      })

      .addCase(AllWhyChooseUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All People behind work actions
      .addCase(AllPeopleBehindWork.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllPeopleBehindWork.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_peoplebehindwork = action.payload || [];
      })

      .addCase(AllPeopleBehindWork.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Why We rank actions
      .addCase(AllWhyWeRank.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllWhyWeRank.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whywerank = action.payload || [];
      })

      .addCase(AllWhyWeRank.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All What make different actions
      .addCase(AllWhatMakeDifferent.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllWhatMakeDifferent.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whatmakedifferent = action.payload || [];
      })

      .addCase(AllWhatMakeDifferent.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All We Focus actions
      .addCase(AllWeFocus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllWeFocus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_wefocus = action.payload || [];
      })

      .addCase(AllWeFocus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All what our customer say actions
      .addCase(AllWhatOurCustomerSay.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllWhatOurCustomerSay.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_whatourcustomersay = action.payload || [];
      })

      .addCase(AllWhatOurCustomerSay.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Man behind power actions
      .addCase(AllManBehindPower.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllManBehindPower.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_manbehindpower = action.payload || [];
      })

      .addCase(AllManBehindPower.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for Best for
      .addCase(AllBestFor.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBestFor.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_bestfor = action.payload || [];
      })
      .addCase(AllBestFor.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for Service
      .addCase(AllService.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllService.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_service = action.payload || [];
      })
      .addCase(AllService.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling all actions for Gallery
      .addCase(AllGallery.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllGallery.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_gallery = action.payload || [];
      })
      .addCase(AllGallery.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All app setup actions
      .addCase(AllAppSetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllAppSetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_appsetup = action.payload || [];
      })

      .addCase(AllAppSetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //All Avgmonthly bill actions
      .addCase(AllAvgMonthlyBill.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllAvgMonthlyBill.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_avgmonthlybill = action.payload || [];
      })
      .addCase(AllAvgMonthlyBill.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //All Consultation Type actions
      .addCase(AllConsultationType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllConsultationType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_consultationtype = action.payload || [];
      })
      .addCase(AllConsultationType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Trusted across communitiy actions
      .addCase(AllTrustedAcrossCommunity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllTrustedAcrossCommunity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_trustedacrosscommunity = action.payload || [];
      })

      .addCase(AllTrustedAcrossCommunity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Subsidy Banner actions
      .addCase(AllSubsidyBanner.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllSubsidyBanner.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_subsidybanner = action.payload || [];
      })

      .addCase(AllSubsidyBanner.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All New Update actions
      .addCase(AllNewUpdate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllNewUpdate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_newupdate = action.payload || [];
      })

      .addCase(AllNewUpdate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Latest announcement actions
      .addCase(AllLatestAnnouncement.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllLatestAnnouncement.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_latestannouncement = action.payload || [];
      })

      .addCase(AllLatestAnnouncement.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Electricity actions
      .addCase(AllElectricity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllElectricity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_electricity = action.payload || [];
      })

      .addCase(AllElectricity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All RooftopSolar actions
      .addCase(AllRooftopSolar.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllRooftopSolar.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_rooftopsolar = action.payload || [];
      })

      .addCase(AllRooftopSolar.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Subsidy Benefit actions
      .addCase(AllSubsidyBenefit.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllSubsidyBenefit.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_subsidybenefit = action.payload || [];
      })

      .addCase(AllSubsidyBenefit.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Privacy policy actions
      .addCase(AllPrivacyPolicy.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllPrivacyPolicy.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_privacypolicy = action.payload || [];
      })

      .addCase(AllPrivacyPolicy.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All terms of service actions
      .addCase(AllTermsOfService.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllTermsOfService.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_termsofservice = action.payload || [];
      })

      .addCase(AllTermsOfService.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Home Banner actions
      .addCase(AllHomeBanner.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllHomeBanner.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_homebanner = action.payload || [];
      })

      .addCase(AllHomeBanner.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handle All total services actions
      .addCase(AllTotalServices.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllTotalServices.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_totalservices = action.payload;
      })

      .addCase(AllTotalServices.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //Handle All Contact us actions
      .addCase(AllContactUs.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllContactUs.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_contactus = action.payload || [];
      })

      .addCase(AllContactUs.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllKeyRequirements.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllKeyRequirements.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_keyrequirements = action.payload || [];
      })

      .addCase(AllKeyRequirements.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllJobTypes.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllJobTypes.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_jobtypes = action.payload || [];
      })
      .addCase(AllJobTypes.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllLocationTypes.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllLocationTypes.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_locationtypes = action.payload || [];
      })
      .addCase(AllLocationTypes.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTimeTypes.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AllTimeTypes.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_timetypes = action.payload || [];
      })
      .addCase(AllTimeTypes.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
